<!-- Hero Section -->
<div class="healthcare-section-bg">
    <section class="healthcare-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h1 class="healthcare-heading mb-3">
                        Media & Entertainment Software Development Solutions for OTT, Ticketing & Beyond
                    </h1>
                    <p class="healthcare-subheading2 mb-4">
                        Transform Entertainment Delivery with scalable OTT platforms, live streaming apps, and mobile
                        ticketing solutions built for scale and for global audiences.
                    </p>
                    <div class="mb-5 contact-btn">
                        <button class="btn hire-btn hire" (click)="scheduleDemo()">
                            Book a Free Consultation
                        </button>
                    </div>
                </div>

                <div class="col-lg-6 text-center">
                    <video #heroVideo preload="auto" src="../../../../assets/industries/entertainment/entertainment-herovideo.webm"
                        class="img-fluid hero-image" autoplay loop muted playsinline disablePictureInPicture>
                    </video>
                </div>
            </div>
        </div>
    </section>
</div>
<!-- Software Solutions in Healthcare Section -->
<section class="solutions-section">
    <div class="container">
        <div class="section-header text-center mx-auto">
            <h2>Why Digital Innovation Matters in Media & Entertainment</h2>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="solutions-image-container">
                    <div class="solution-image-card image-one">
                        <div class="image-overlay"></div>
                        <img src="../../../../assets/industries/entertainment/media-img1.png"
                            alt="Team collaborating on computer">
                    </div>
                    <div class="solution-image-card image-two">
                        <div class="image-overlay"></div>
                        <img src="../../../../assets/industries/entertainment/media-img2.png"
                            alt="Two colleagues looking at a laptop">
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="solutions-content">
                    <p>
                        The Media & Entertainment industry is rapidly evolving with changing audience expectations,
                        demand for real-time content, multi-device consumption, and the need for seamless digital
                        distribution. In addition, emerging trends like AI-powered recommendations, blockchain for
                        rights management, or Web3 integration are driving innovation. Challenges such as scalability,
                        copyright protection, performance optimization, and data-driven personalization require robust
                        media and entertainment software development expertise.
                    </p>
                    <p>
                        At Kalpita Technologies, we empower businesses with digital media software solutions, custom OTT
                        platforms, live streaming capabilities, and secure ticketing systems that support high traffic,
                        rich content delivery, and superior user experience.
                    </p>
                    <p><strong>Key Benefits of Innovative Software Solutions in Media & Entertainment</strong></p>
                    <div class="features-list">
                        <ul>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Secure, seamless
                                content and ticketing workflows</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">50% faster content
                                delivery across platforms</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Scalable
                                architecture and 99.9% uptime during peak traffic and live events</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">Personalized user
                                experiences powered by analytics</li>
                            <li><img src="../../../assets/home/arrow-indicator.svg" alt="Indicator">3x increase in
                                audience engagement & retention</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Our Solutions & Impact Section -->
<section class="impact-section" #impactSection>
    <div class="container">
        <div class="text-center">
            <h2 class="impact-heading">Kalpita Technologies’ Media & Entertainment Solutions</h2>
        </div>
        <div class="row align-items-center impact-main-content">
            <!-- Added Animation Trigger -->
            <div class="col-lg-6" [@fadeInUpStagger]="impactSectionVisible ? 'visible' : 'hidden'">
                <!-- Added animate-item class -->
                <p class="impact-description animate-item">
                    We deliver end-to-end digital services tailored to Media & Entertainment brands, right from live
                    streaming app development, OTT platform development, and mobile ticketing app development to content
                    workflow automation, cloud migration, UI/UX modernization, and analytics-driven personalization. Our
                    solutions are built on Azure or AWS, leveraging AI/ML for personalization and microservices
                    architecture.
                </p>
                <!-- Added animate-item class -->
                <p class="impact-description animate-item">
                    Whether you want to build an OTT streaming app or a ticketing app, our expert engineering team
                    ensures a secure, scalable, and high-performance solution aligned with your business model.
                </p>
            </div>
            <div class="col-lg-6">
                <!-- Added Shine Effect -->
                <div class="impact-image-wrapper">
                    <img src="../../../../assets/industries/entertainment/entertainment-solutions-img.png"
                        alt="Developer working on multiple screens">
                    <div class="shine"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Case Studies Section -->
<section class="case-studies-section">
    <div class="container">

        <div class="row justify-content-center text-center mb-5">
            <div class="col-lg-8">
                <h2 class="section-heading">Proven Result From Our Media & Entertainment Project</h2>
                <!-- <p class="section-subheading">Real-world examples of our healthcare solutions in action.</p> -->
            </div>
        </div>

        <!-- Slider Wrapper -->
        <div class="case-study-slider-container" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">

            <!-- The Sliding Track -->
            <div class="slider-viewport">
                <div class="slider-track" [style.transform]="'translateX(-' + (currentSlide * 100) + '%)'"
                    [class.single-slide]="caseStudies.length === 1">

                    <!-- Loop through Case Studies -->
                    <div class="case-study-slide" *ngFor="let study of caseStudies">
                        <div class="row align-items-center">

                            <!-- Image Column (Left) -->
                            <div class="col-lg-5 d-flex justify-content-center">
                                <div class="case-study-image-wrapper">
                                    <img [src]="study.image" [alt]="study.title" class="img-fluid">
                                </div>
                            </div>

                            <!-- Content Column (Right) -->
                            <div class="col-lg-7">
                                <div class="case-study-content">
                                    <h3 class="case-study-title">{{ study.title }}</h3>
                                    <p class="case-study-description">
                                        {{ study.description }}
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- End Loop -->
                </div>
            </div>

            <!-- Pagination Dots -->
            <div class="slider-dots" *ngIf="caseStudies.length > 1">
                <span *ngFor="let study of caseStudies; let i = index" class="dot" [class.active]="i === currentSlide"
                    (click)="goToSlide(i)">
                </span>
            </div>
        </div>
    </div>
</section>
<!-- Testimonial Section -->
<!-- <section class="written-testimonial-section custom-testimonial written-testimonial-wrapper">
  <h2 class="written-heading">Testimonials</h2>

  <app-clients-testimonal [hideHeading]="true"></app-clients-testimonal>
</section> -->
<div class="healthcare-section-bg">
    <section class="healthcare-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <h2 class="healthcare-heading mb-3">
                        Testimonials
                    </h2>
                    <div class="mb-5 contact-btn">
                        <button class="btn hire-btn hire" (click)="testimonials()">
                            See What Our Clients Say
                        </button>
                    </div>
                </div>

                <div class="col-lg-6 text-center">
                    <img src="../../../../assets/clientscta/clientsctaimage.webp" alt="Clients CTA"
                        class="img-fluid testimonial-hero-image">
                </div>
            </div>
        </div>
    </section>
</div>
<!-- FAQ -->
<app-faq [faqList]="mediaFaqs"></app-faq>
<!-- Final CTA -->
<div class="final-cta-bg">
    <img src="../../../../assets/industries/healthcare/half-tablet.png" alt="Decorative capsule"
        class="cta-capsule-img">
    <section id="final-cta" class="final-cta-section container">
        <div class="section-header text-center mx-auto">
            <!-- <h2>Final CTA</h2> -->
        </div>
        <div class="row align-items-center">
            <div class="col-lg-6 cta-content-col">
                <h2 class="cta-heading-small">Let’s Build Your Next Digital Entertainment Experience</h2>
                <div class="mb-5 cta-btn-group">
                    <!-- <button class="btn btn-get-started me-3" (click)="getStarted()">
            Get Started
          </button> -->
                    <button class="btn btn-schedule-demo" (click)="scheduleDemo()">
                        Schedule a Free Consultation
                    </button>
                </div>
            </div>
            <div class="col-lg-6 text-center">
                <img src="../../../../assets/industries/healthcare/health-pod-clinic.png" alt="Health POD Clinic"
                    class="img-fluid cta-clinic-image">
            </div>
        </div>
    </section>
</div>
<!-- Explore More Industries -->
<app-explore-more-industries></app-explore-more-industries>